import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { Assistant, CoachingFeedbackResponse, DonorFeedbackResponse, Nullable } from '@/types/simulations';
import { GetTranscriptionResponse } from '@/types/transcription';

interface StoreState {
  showFirstScenario: boolean;
  setShowFirstScenario: (value: boolean) => void;
  simulationType: string;
  setSimulationType: (value: string) => void;
  formData: any;
  setFormData: (value: any) => void;
  hasPreviousPractices: boolean;
  setHasPreviousPractices: (value: any) => void;
  assistant: Assistant | null;
  setAssistant: (value: Assistant) => void;
  coachingFeedback: Nullable<CoachingFeedbackResponse>;
  setCoachingFeedback: (value: Nullable<CoachingFeedbackResponse>) => void;
  donorFeedback: Nullable<DonorFeedbackResponse>;
  setDonorFeedback: (value: Nullable<DonorFeedbackResponse>) => void;
  transcription: Nullable<GetTranscriptionResponse>;
  setTranscription: (value: Nullable<GetTranscriptionResponse>) => void;
  resetStore: () => void;
  // TODO: Create subscription or user store and move it
  balance: number;
  setBalance: (value: number) => void;
}

const initialState = {
  showFirstScenario: false,
  simulationType: '',
  formData: null,
  simulationId: '',
  hasPreviousPractices: false,
  assistant: null,
  coachingFeedback: undefined,
  donorFeedback: undefined,
  transcription: undefined,
  // TODO: Create subscription or user store and move it
  balance: 0
};

export const useSimulationStore = create<StoreState>()(
  persist(
    set => ({
      ...initialState,
      setShowFirstScenario: (val: boolean) => set({ showFirstScenario: val }),
      setSimulationType: (value: string) => set({ simulationType: value }),
      setFormData: (value: any) => set({ formData: value }),
      setHasPreviousPractices: (value: boolean) => set({ hasPreviousPractices: value }),
      setAssistant: (value: Assistant) => set({ assistant: value }),
      setCoachingFeedback: (value: Nullable<CoachingFeedbackResponse>) => set({ coachingFeedback: value }),
      setDonorFeedback: (value: Nullable<DonorFeedbackResponse>) => set({ donorFeedback: value }),
      setTranscription: (value: Nullable<GetTranscriptionResponse>) => set({ transcription: value }),
      resetStore: () =>
        set(state => ({ ...initialState, hasPreviousPractices: state.hasPreviousPractices, balance: state.balance })),
      // TODO: Create subscription or user store and move it
      setBalance: (value: number) => set({ balance: value })
    }),
    {
      name: 'practivated-simulation-storage',
      partialize: state => ({
        hasPreviousPractices: state.hasPreviousPractices,
        // TODO: Create subscription or user store and move it
        balance: state.balance
      })
    }
  )
);
